var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var HeadingName = /** @class */ (function (_super) {
    __extends(HeadingName, _super);
    function HeadingName() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeadingName.prototype.render = function () {
        return (React.createElement("div", { key: "k_" + name, className: "rj-ev-list__heading-name", "data-uat": "div-ev-list-heading-name" }, this.props.name));
    };
    return HeadingName;
}(React.PureComponent));
export { HeadingName };
//# sourceMappingURL=HeadingName.js.map